import React, { ReactNode, createContext, useMemo } from "react";
import {
  Client,
  getContract,
  GetContractReturnType,
  PublicClient,
  WalletClient,
} from "viem";
import ISmartUnits from "./ISmartUnits";
import { useConnection } from "@eveworld/contexts";

interface SmartUnitsContract {
  SmartUnitsContract: GetContractReturnType<
    typeof ISmartUnits.abi,
    Client
  > | null;
}

const SmartUnitsProvider = ({ children }: { children: ReactNode }) => {
  const { defaultNetwork, publicClient, walletClient } = useConnection();

  const SmartUnitsContract = useMemo(
    () =>
      getContract({
        abi: ISmartUnits.abi,
        address: defaultNetwork.worldAddress,
        client: {
          public: publicClient as PublicClient,
          wallet: walletClient as WalletClient,
        },
      }),
    [publicClient, walletClient]
  );

  return (
    <SmartUnitsContext.Provider value={{ SmartUnitsContract }}>
      {children}
    </SmartUnitsContext.Provider>
  );
};

export const SmartUnitsContext = createContext<SmartUnitsContract>({
  SmartUnitsContract: null,
});

export default SmartUnitsProvider;
